package nl.volleyplanner.api.planner

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable


@Serializable
data class PlannerSeasonPrerequisites(
    val seasonName: String,
    val refereeGroupCount: Long,
    val nevoboTeamCount: Long,
    val volunteerCount: Long,
)

@Serializable
data class PlannerPrerequisites(
    val nevoboSyncInProgress: Boolean,
    val lastNevoboSyncDateTime: LocalDateTime?,
    val memberCount: Long,
    val lastMemberUpload: LocalDateTime?,
    val seasonPrequisites: Map<String, PlannerSeasonPrerequisites>
)